<template>
  <transition name="consent">
    <div v-if="show" class="consent" role="dialog" aria-live="polite">
      <p>{{ c.consent.text }}</p>
      <div class="consent__btns">
        <button class="btn btn--sm btn--ghost" @click="choose(false)">{{ c.consent.reject }}</button>
        <button class="btn btn--sm btn--primary" @click="choose(true)">{{ c.consent.accept }}</button>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref } from 'vue'
import { content as c } from '@/i18n'
import { hasThirdPartyTags, readConsent, setConsent } from '@/track'

// 只有配置了 Google / X / 百度 代码时才出现
const show = ref(hasThirdPartyTags && !readConsent())
function choose(ok) { setConsent(ok); show.value = false }
</script>

<style scoped>
.consent {
  position: fixed; left: 16px; bottom: 16px; z-index: 350; max-width: 420px;
  background: var(--ink-3); border: 1px solid var(--ink-line); color: var(--ink-text);
  padding: 18px 20px; box-shadow: 0 16px 40px rgba(0,0,0,.4); font-size: 14px;
}
.consent__btns { display: flex; gap: 10px; margin-top: 14px; justify-content: flex-end; }
.consent__btns .btn { width: auto; }
.consent-enter-active, .consent-leave-active { transition: opacity .25s, transform .25s; }
.consent-enter-from, .consent-leave-to { opacity: 0; transform: translateY(10px); }
@media (max-width: 600px) { .consent { right: 16px; max-width: none; } }
</style>
